<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Grupy pakowania</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <router-link to="/packages">Grupy pakowania</router-link>
        </li>
        <li class="active">
          <strong>Nowa</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Grupy pakowania</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="packageObj.name"
                    name="name"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.name" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.name[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">W x H x L [cm]</label>
                <div class="col-sm-10 flex-inputs">
                  <div>
                    <input
                      v-model="packageObj.width"
                      name="width"
                      type="text"
                      class="form-control inputClass"
                      placeholder="Szerokość"
                      required="required"
                    />
                    <div v-if="errorsAdminData?.data?.width" class="has-error">
                      <span class="help-block">
                        {{ errorsAdminData.data.width[0] }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <input
                      v-model="packageObj.height"
                      name="height"
                      type="text"
                      class="form-control inputClass"
                      placeholder="Wysokość"
                      required="required"
                    />
                    <div v-if="errorsAdminData?.data?.height" class="has-error">
                      <span class="help-block">
                        {{ errorsAdminData.data.height[0] }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <input
                      v-model="packageObj.length"
                      name="length"
                      type="text"
                      class="form-control inputClass"
                      placeholder="Długość"
                      required="required"
                    />
                    <div v-if="errorsAdminData?.data?.length" class="has-error">
                      <span class="help-block">
                        {{ errorsAdminData.data.length[0] }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  Maksymalna waga [kg]
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="packageObj.max_weight"
                    name="max_weight"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Maksymalna waga [kg]"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.max_weight"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.max_weight[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="hr-line-dashed"></div>

              <div class="form-group">
                <div class="col-sm-4 col-sm-offset-2">
                  <router-link class="btn btn-white" to="/packages">
                    Anuluj
                  </router-link>
                  <button
                    v-if="canAddPackage"
                    @click="create"
                    class="btn btn-primary"
                  >
                    Dodaj
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { hasPermission } from "../../permissions";
import { packagePermissionsConst } from "../../constants/productConstants";
import { useStore } from "vuex";
import router from "../../router/router";

export default {
  name: "PackagesCreate",
  mixins: [],
  components: {},
  props: {},

  setup() {
    const canAddPackage = computed(() =>
      hasPermission(packagePermissionsConst.add)
    );
    const packageObj = ref({
      name: "",
      width: "",
      height: "",
      length: "",
      max_weight: "",
    });

    const errorsAdminData = ref();
    const showErrors = ref(false);
    const store = useStore();
    const createPackagesData = computed(
      () => store.getters.getCreatePackagesData
    );

    const create = () => {
      if (!canAddPackage.value) {
        return;
      }
      showErrors.value = true;
      store.dispatch("createPackages", packageObj.value);
    };

    watch(
      () => createPackagesData.value,
      function (newValue) {
        if (newValue.status === 201) {
          router.push({ name: "PackagesList", path: "/packages" }).then(() => {
            store.dispatch("showToaster", {
              type: "success",
              content: "Nowa grupa została dodana",
            });
          });
        } else {
          var msg = [];
          for (const [key, value] of Object.entries(newValue.data)) {
            msg.push(key + ": " + value);
          }

          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
        }
      }
    );

    return {
      canAddPackage,
      packageObj,
      errorsAdminData,
      showErrors,
      create,
    };
  },
  computed: {},
};
</script>
